import 'Api/customAxios';
import AuthContext from 'context/AuthContext';
import ErrorPage from 'pages/ErrorPage';
import Logout from 'pages/Logout';
import { useEffect, useMemo, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { Route, Routes } from 'react-router-dom';

import Loader from 'components/Loader/Loader';

import { ProtectedRouteOutlet } from '../Routes/ProtectedRoute';
import protectedRoutes from '../Routes/routes';
import LoginFlow from '../pages/LoginFlow/LoginFlow';

const App = () => {
  const [loader, setLoader] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [idToken, setIdToken] = useState('');
  const [fullName, setFullName] = useState('');
  const [userID, setUserID] = useState('');
  const [username, setUserName] = useState('');
  const [isUserIdle, setIsUserIdle] = useState(false);
  const [initiateUiResponse, setInitiateUiResponse] = useState(null);
  const authObj = {
    accessToken,
    setAccessToken,
    idToken,
    setIdToken,
    fullName,
    setFullName,
    userID,
    setUserID,
    username,
    setUserName,
    isUserIdle,
    setIsUserIdle,
    initiateUiResponse,
    setInitiateUiResponse,
  };
  const authContextValue = useMemo(
    () => ({
      ...authObj,
    }),
    [{ ...authObj }]
  );

  const handleOnIdle = () => {
    setIsUserIdle(true);
  };

  const { getRemainingTime } = useIdleTimer({
    timeout: 780000,

    onIdle: handleOnIdle,
    events: ['mousemove', 'DOMMouseScroll', 'click', 'keypress', 'submit', 'keydown', 'keyup'],
  });
  console.log(getRemainingTime());
  useEffect(() => {
    setLoader(true);
    const timer = setTimeout(() => {
      setLoader(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AuthContext.Provider value={authContextValue}>
      <Loader open={loader} />
      <Routes>
        <Route exact path="/login" element={<LoginFlow />}></Route>
        <Route exact path="/logout" element={<Logout />}></Route>
        <Route exact path="/saml-error" element={<ErrorPage />}></Route>
        {protectedRoutes.map((x) => (
          <Route key={x.path} path={x.path} exact element={<ProtectedRouteOutlet />}>
            <Route path="" element={x.element} />
          </Route>
        ))}
      </Routes>
    </AuthContext.Provider>
  );
};

export default App;
